import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import {
	ContentContainer,
	TitleHeader,
	TableLoading,
	MaterialIcon,
} from "../components/UiComponents";
import {
	CourseHeader,
	CourseWrapper,
} from "../components/CourseComponents";
import useDocumentTitle from "../components/useDocumentTitle";

const WrittenAssessmentsPage = () => {
	const { dispatch, api, state } = useAppContext();
	const isOffline = state.offline;
	useDocumentTitle("PMVA Assessments");
	const [loading, setLoading] = useState(true);
	let course = api.getCurrentCourse();

	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		if (isOffline) {
			setLoading(false);
			return;
		}

		const { data } = await api.fetchData(
			`/courses/${course.id}/students`
		);

		if (data?.students) {
			dispatch({
				type: "SET_COURSE_STUDENTS",
				payload: {
					students: data.students,
					course_id: course.id,
				},
			});
			setLoading(false);
		} else {
			setLoading(false);
		}
	}

	return (
		<div className="written-assessments-page">
			<CourseHeader />
			<ContentContainer classes="mb-4">
				<CourseWrapper>
					<TitleHeader title={`PMVA Assessments`} />
					<div className="written-assessments">
						{loading ? (
							<TableLoading rows={5} />
						) : (
							<>
								{course.students.length == 0 ? (
									<div className="written-assessments__empty">
										<p>No students have registered yet.</p>
									</div>
								) : (
									<>
										<StudentsTable students={course.students} />
									</>
								)}
							</>
						)}
					</div>
				</CourseWrapper>
			</ContentContainer>
		</div>
	);
};

const StudentsTable = ({ students }) => {
	if (students.length == 0) {
		return null;
	}
	return (
		<table className="table table-striped responsive-table students-table">
			<thead>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th className="text-center">Submitted</th>
					<th className="text-center">Marked</th>
					<th className="text-center">Score</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{students.map((student) => (
					<StudentsTableRow student={student} key={student.id} />
				))}
			</tbody>
		</table>
	);
};

const StudentsTableRow = ({ student }) => {
	const { state, dispatch, api } = useAppContext();
	const isOffline = state.offline;
	const course = api.getCurrentCourse();
	const studentId = student.id;
	const assessment = student.written_assessment;
	const submitted = assessment?.submitted_at;

	return (
		<tr>
			<td>
				{student.first_name} {student.last_name}
			</td>
			<td>{student.email}</td>
			<td className="text-center" data-label="Submitted">
				<MaterialIcon
					icon={submitted ? "check" : "close"}
					className={`text-${submitted ? "success" : "danger"
						}`}
				/>
			</td>
			<td className="text-center" data-label="Marked">
				<MaterialIcon
					icon={assessment?.tutor_marked_at ? "check" : "close"}
					className={`text-${assessment?.tutor_marked_at ? "success" : "danger"
						}`}
				/>
			</td>
			<td className="text-center" data-label="Score">
				{assessment ? assessment.total_score : "-"}
			</td>
			<td className="text-center">
				{assessment?.submitted_at && (
					<Link
						className="btn btn-sm btn-tertiary"
						to={`/courses/${course.id}/written-assessments/${studentId}`}
						style={isOffline ? { pointerEvents: "none", opacity: 0.8 } : {}}
					>
						{assessment?.tutor_marked_at ? "Review" : "Mark"}
					</Link>
				)}
			</td>
		</tr>
	);
};

export default WrittenAssessmentsPage;
